import React, {useEffect, useState} from 'react';
import close from "../../../images/close.svg";
import pick from '../../../images/pick-photo.png'
import upload from '../../../images/blue_upload.svg'
import {Field, Formik} from "formik";
import arrowDown from "../../../images/input-arrow.svg";
import infoIcon from "../../../images/info-circle.svg";
import {yachtsModels} from "../../../redux/types";
import plus from "../../../images/blue-plus.svg";
import ReactTooltip from "react-tooltip";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getCommonData} from "../../../redux/data/data-thunks";
import {OPERATORS, YACHT_MODELS, YACHT_TYPES} from "../../../redux/data/data-types";
import * as Yup from "yup";
import {userApi} from "../../../redux/user/user-api";
import {dataApi} from "../../../redux/data/data-api";
import {profileApi} from "../../../redux/profile/profile-api";
import {addFavoriteYacht} from "../../../redux/profile/profile-thunks";
import {isCyrilic} from "../../../utils";

const AddYacht = ({closeModal, openCreateModal, editYacht, getCommonData, ...props}) => {
  const {t} = useTranslation()
  const {isDark} = useTheme()
  const [file, setFile] = useState(null)
  console.log(editYacht)
  useEffect(() => {
    if (editYacht) {
      getCommonData(YACHT_MODELS, editYacht.yacht.yacht_model.name)
      getCommonData(OPERATORS, editYacht.yacht.operator?.name ?? '')
    } else {
      getCommonData(YACHT_MODELS)
    }
    getCommonData(YACHT_TYPES)
    getCommonData(OPERATORS)
  }, [])

  const onSubmit = async (values, {setFieldError}) => {
    let isAnyError = false
    if(!isCyrilic(values.yacht)) {
      isAnyError = true
      setFieldError('yacht', `${t('enter')} ${t('yachtName')} ${t('onlyEnglish')}`)
    }
    if (!values.isPrivateOwn && !props.operators.find(o => o.name === values.operator)) {
      isAnyError = true
      setFieldError('operator', t('operatorNotFound'))
    }
    if (!props.yachtModels.find(y => y.name === values.model) ) {
      isAnyError = true
      setFieldError('model', t('modelNotFound'))
    }
    if(!isAnyError) {
      const yachtModelId = props.yachtModels.find(y => y.name === values.model)?.id ?? null
      const operatorId = props.operators.find(o => o.name === values.operator)?.id ?? null
      const yachtTypeId = props.yachtTypes.find(y => y.name === values.type)?.id ?? null
      let imageLink = editYacht?.yacht?.yacht_image_id ?? null
      if(file) {
        const response = await userApi.uploadFile(file, false)
        imageLink = response.data.id
      }
      if(editYacht) {
        props.addFavoriteYacht({
          name: values.yacht,
          year: values.year,
          yacht_model_id: yachtModelId,
          operator_id: operatorId,
          yacht_owner_name: values.owner,
          isPrivateOwn: values.isPrivateOwn,
          yacht_type_id: yachtTypeId,
          yacht_image_id: imageLink,
          editYachtId: editYacht.yacht.id
        })
        closeModal()
      } else {
        props.addFavoriteYacht({
          name: values.yacht,
          year: values.year,
          yacht_model_id: yachtModelId,
          operator_id: operatorId,
          yacht_owner_name: values.owner,
          isPrivateOwn: values.isPrivateOwn,
          yacht_type_id: yachtTypeId,
          yacht_image_id: imageLink,
        })
        closeModal()
      }
    }
  }

  return (
    <div className={`modal ${isDark && 'modal__dark'} w-830`}>
      <h5 className="modal__mainTitle mr-30">{editYacht !== null ? t('editYachtInfo') : t('addYacht')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <Formik
        initialValues={{
          model: editYacht ? editYacht.yacht.yacht_model.name : '',
          yacht: editYacht ? editYacht.yacht.name : '',
          year: editYacht?.yacht?.year ?? '',
          type: editYacht?.yacht?.yacht_type?.name ?? '',
          isPrivateOwn: !!editYacht?.yacht?.yacht_owner_name,
          owner: editYacht?.yacht?.yacht_owner_name ?? '',
          operator: editYacht?.yacht?.operator?.name ?? ''
        }}
        onSubmit={onSubmit}
        validationSchema={Yup.object({
          year: Yup.string()
            .required(t('chooseYearList')),
          type: Yup.string()
            .required(t('chooseYachtType')),
        })}
      >
        {({values, handleChange, handleSubmit, setFieldValue, errors, submitCount}) => {
          errors = submitCount > 0 ? errors : {}
          return <>
            <div className="modal__sections modal__row">
              <div>
                <div className="modal__pickPhoto">
                  <label htmlFor="photo" className="modal__pickWrapper">
                    <img src={file !== null ? URL.createObjectURL(file) : editYacht?.image ? `data:image/png;base64,${editYacht?.image}` : pick} alt=""/>
                  </label>
                  <input onChange={e => setFile(e.target.files[0])} id={'photo'} type="file" className="modal__file"/>
                  <label htmlFor={'photo'} className="modal__upload">
                    <img src={upload} alt=""/>
                    {t('uploadPhoto')}
                  </label>
                </div>
              </div>
              <div className="modal__section mt-0 w-100">
                <div className="modal__inputs show-block">
                  <div className="modal__inputItem mt-0">
                    <p className="modal__label w-120">{t('model')}:</p>
                    <div className="modal__inputWrapper w-100">
                      <Field placeholder={t('modelName')} autoComplete={'off'} value={values.model} id={'model'}
                             onChange={e => {
                               handleChange(e)
                               getCommonData(YACHT_MODELS, e.target.value)
                             }} type="text" className={`modal__input w-100 ${errors.model && 'modal__inputError'}`}/>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.yachtModels?.map((y, index) => <button className="modal__listItem"
                                                                        onClick={() => setFieldValue('model', y.name)}
                                                                        key={index}>
                            {y.name}
                          </button>)}
                        </div>
                        <button onClick={openCreateModal} className="modal__list-add">
                          <img src={plus} alt="" className={'modal__list-icon'}/>
                          {t('addNewModel')}
                        </button>
                      </div>
                    </div>
                  </div>
                  {errors.model && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label w-120"/>
                    <p className="modal__errorText">{errors.model}</p>
                  </div>}
                  <div className="modal__inputItem">
                    <p className="modal__label w-120">{t('yachtName')}:</p>
                    <div className="modal__inputWrapper w-100">
                      <Field placeholder={t('yachtName')} autoComplete={'off'} value={values.yacht} id={'yacht'}
                             onChange={handleChange} type="text" className={`modal__input w-100 ${errors.yacht && 'modal__inputError'}`}/>
                    </div>
                  </div>
                  {errors.yacht && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label w-120"/>
                    <p className="modal__errorText">{errors.yacht}</p>
                  </div>}
                  <div className="modal__inputItem">
                    <p className="modal__label w-120">{t('year')}:</p>
                    <div className="modal__inputWrapper w-260">
                      <Field placeholder={t('chooseYear')} autoComplete={'off'} value={values.year} id={'year'}
                             onChange={handleChange} type="number" className={`modal__input w-100 ${errors.year && 'modal__inputError'}`}/>
                      <button className="modal__arrowIcon">
                        <img src={arrowDown} alt=""/>
                      </button>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {[...Array(71)].map((_, index) => new Date().getFullYear() - index)
                            .map((y, index) => <button className="modal__listItem"
                                                       onClick={() => setFieldValue('year', y)} key={index}>
                              {y}
                            </button>)}
                        </div>
                      </div>
                    </div>
                    <button data-tip data-for={'year'} className="modal__infoButton">
                      <img src={infoIcon} alt=""/>
                    </button>
                    <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'year'} place="top"
                                  effect="solid">
                      {t('chooseYearList')}
                    </ReactTooltip>
                  </div>
                  {errors.year && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label w-120"/>
                    <p className="modal__errorText">{errors.year}</p>
                  </div>}
                  <div className="modal__inputItem">
                    <p className="modal__label w-120">{t('yachtType')}:</p>
                    <div className="modal__inputWrapper w-100">
                      <Field placeholder={t('notChosen')} autoComplete={'off'} value={values.type} id={'type'}
                             onChange={() => {
                             }} type="text" className={`modal__input w-100 ${errors.type && 'modal__inputError'}`}/>
                      <div className="modal__list">
                        <div className="modal__listItems">
                          {props.yachtTypes.map((y, index) => <button className="modal__listItem"
                                                                      onClick={() => {
                                                                        setFieldValue('type', y.name)
                                                                        setFieldValue('type_id', y.id)
                                                                      }} key={index}>
                            {y.name}
                          </button>)}
                        </div>
                      </div>
                      <button className="modal__arrowIcon">
                        <img src={arrowDown} alt=""/>
                      </button>
                    </div>
                    <button className="modal__infoButton">
                      <img src={infoIcon} alt=""/>
                    </button>
                  </div>
                  {errors.type && <div className={'modal__inputItem mt-0'}>
                    <p className="modal__label w-120"/>
                    <p className="modal__errorText">{errors.type}</p>
                  </div>}
                  <div className="modal__inputItem">
                    <p className="modal__label w-120">{t('ownerShip')}:</p>
                    <div className="modal__checks">
                      <div className="modal__checkWrapper">
                        <div onClick={() => setFieldValue('isPrivateOwn', false)}
                             className={`modal__checkbox ${!values.isPrivateOwn && 'modal__checkboxSelected'}`}>
                          {!values.isPrivateOwn && <div className="modal__circle"/>}
                        </div>
                        <p className="modal__checkboxText">{t('charter')}</p>
                      </div>
                      <div className="modal__checkWrapper">
                        <div onClick={() => setFieldValue('isPrivateOwn', true)}
                             className={`modal__checkbox ${values.isPrivateOwn && 'modal__checkboxSelected'}`}>
                          {values.isPrivateOwn && <div className="modal__circle"/>}
                        </div>
                        <p className="modal__checkboxText">{t('private')}</p>
                      </div>
                    </div>
                  </div>
                  <div className="modal__inputItem">
                    {!values.isPrivateOwn ? <>
                      <p className="modal__label w-120">{t('operator')}: <span className={'required'}>*</span></p>
                      <div className="modal__inputWrapper w-100">
                        <Field placeholder={t('notChosen')} value={values.operator} id={'operator'}
                               onChange={e => {
                                 handleChange(e)
                                 getCommonData(OPERATORS, e.target.value)
                               }} type="text" className={`modal__input w-100 ${errors.operator && 'modal__inputError'}`}
                               autoComplete={"off"}/>
                        <div className="modal__list">
                          <div className="modal__listItems">
                            {props.operators.map((o, index) => <button className="modal__listItem"
                                                                       onClick={() => setFieldValue('operator', o.name)}
                                                                       key={index}>
                              {o.name}
                            </button>)}
                          </div>
                        </div>
                      </div>
                    </> : <>
                      <p className="modal__label w-120">{t('yachtOwner')}:</p>
                      <div className="modal__inputWrapper w-100">
                        <Field placeholder={t('fleetOperator')} autoComplete={'off'} value={values.owner}
                               id={'owner'}
                               onChange={handleChange} type="text" className="modal__input w-100"/>
                      </div>
                    </>}
                    <button data-tip data-for={'operator'} className="modal__infoButton">
                      <img src={infoIcon} alt=""/>
                    </button>
                    <ReactTooltip className={'tooltip'} backgroundColor={'#F7F8FB'} id={'operator'} place="left"
                                  effect="solid">
                      {t('operatorTint')}
                    </ReactTooltip>
                  </div>
                  {!values.isPrivateOwn && <>
                    {errors.operator && <div className={'modal__inputItem mt-0'}>
                      <p className="modal__label w-120"/>
                      <p className="modal__errorText">{errors.operator}</p>
                    </div>}
                  </>}
                </div>
              </div>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button onClick={handleSubmit} disabled={Object.keys(errors).length !== 0}
                        className={`submit-button ${Object.keys(errors).length !== 0 && 'submit-button__disabled'}`}>
                  {editYacht !== null ? t('edit') : t('add')}
                </button>
                <button className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                  <span className="commonBtn__label">{t('cancel')}</span>
                </button>
              </div>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  yachtModels: state.dataReducer.yachtModels,
  yachtTypes: state.dataReducer.yachtTypes,
  operators: state.dataReducer.operators,
  profile: state.userReducer.profile
})

export default connect(mapStateToProps, {getCommonData, addFavoriteYacht})(React.memo(AddYacht))
